export default {
  vacancies: []
};
